"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _generalStore = require("general-store");

var _ComponentWithLoadingState = _interopRequireDefault(require("UIComponents/mixins/ComponentWithLoadingState"));

var _SidebarLoading = _interopRequireDefault(require("crm_ui/sidebar/loading/SidebarLoading"));

var _ProfileIntegrationsLinkedSalesObject = _interopRequireDefault(require("crm_ui/profile/sidebar/integrations/ProfileIntegrationsLinkedSalesObject"));

var _LinkedSalesObjectActions = _interopRequireDefault(require("crm_ui/flux/integrations/LinkedSalesObjectActions"));

var _LinkedSalesObjectStore = _interopRequireDefault(require("crm_ui/flux/integrations/LinkedSalesObjectStore"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _loggers = require("customer-data-tracking/loggers");

var ProfileIntegrationsLinkedSalesObjectContainer = (0, _createReactClass.default)({
  displayName: 'ProfileIntegrationsLinkedSalesObjectContainer',
  mixins: [_ComponentWithLoadingState.default],
  propTypes: {
    associatedObjectId: _propTypes.default.number.isRequired,
    associatedObjectType: _propTypes.default.oneOf([_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL]).isRequired,
    linkedSalesObject: _propTypes.default.instanceOf(_immutable.Map).isRequired,
    linkedSalesObjectContent: _propTypes.default.instanceOf(_immutable.Map)
  },
  getInitialState: function getInitialState() {
    return {
      activeIframe: null
    };
  },
  openIframeModal: function openIframeModal(action, parentTitle) {
    var linkedSalesObject = this.props.linkedSalesObject;

    _loggers.CrmLogger.log('use-linked-sales-object-iframe', {
      applicationName: linkedSalesObject.get('appName')
    });

    return this.setState({
      activeIframe: {
        action: action,
        parentTitle: parentTitle
      }
    });
  },
  closeIframeModal: function closeIframeModal() {
    var _this$props = this.props,
        associatedObjectId = _this$props.associatedObjectId,
        associatedObjectType = _this$props.associatedObjectType,
        linkedSalesObject = _this$props.linkedSalesObject;
    this.setState({
      activeIframe: null
    });
    return _LinkedSalesObjectActions.default.fetch({
      objectTypeId: linkedSalesObject.get('objectTypeId'),
      associatedObjectId: associatedObjectId,
      associatedObjectType: associatedObjectType
    });
  },
  getIsLoaded: function getIsLoaded() {
    var linkedSalesObjectContent = this.props.linkedSalesObjectContent;
    var content = linkedSalesObjectContent.get('content');
    return content && content.size || linkedSalesObjectContent.get('error');
  },
  renderLoading: function renderLoading() {
    return _react.default.createElement(_SidebarLoading.default, null);
  },
  renderComplete: function renderComplete() {
    return _react.default.createElement(_ProfileIntegrationsLinkedSalesObject.default, (0, _extends2.default)({}, this.props, {
      activeIframe: this.state.activeIframe,
      closeIframeModal: this.closeIframeModal,
      openIframeModal: this.openIframeModal
    }));
  }
});

var _default = (0, _generalStore.connect)({
  linkedSalesObjectContent: {
    stores: [_LinkedSalesObjectStore.default],
    deref: function deref(props) {
      var associatedObjectId = props.associatedObjectId,
          associatedObjectType = props.associatedObjectType,
          linkedSalesObject = props.linkedSalesObject;

      var salesObject = _LinkedSalesObjectStore.default.get({
        objectTypeId: linkedSalesObject.get('objectTypeId'),
        associatedObjectId: associatedObjectId,
        associatedObjectType: associatedObjectType
      });

      if (!salesObject) return undefined;
      return salesObject.getIn([associatedObjectType, associatedObjectId, linkedSalesObject.get('objectTypeId')]);
    }
  }
})(ProfileIntegrationsLinkedSalesObjectContainer);

exports.default = _default;
module.exports = exports.default;